import Vue from 'vue';
import Vuex from 'vuex';
import me from '@/store/me';
import search from '@/store/search';
import location from '@/store/location';
import category from '@/store/category';
import attribute from '@/store/attribute';
import classification from '@/store/classification';
import user from '@/store/user';

Vue.use(Vuex);

// eslint-disable-next-line
export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        me,
        user,
        search,
        location,
        category,
        attribute,
        classification,
    },
});
